import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-crm-display-field',
  templateUrl: './crm-display-field.component.html',
  styleUrls: ['./crm-display-field.component.scss'],
})
export class CrmDisplayFieldComponent implements OnInit {
  @Input() url: string;
  @Input() record: any;
  @Input() entry: {
    field_type: string;
    reference_to: string;
    reference_field_type: string;
    reference_field_name: string;
    field_name: string;
  };

  entryToDisplay!: { field_name: string; field_type: string };
  data!: any;

  ngOnInit(): void {
    const { field_type, field_name, reference_field_type, reference_field_name } = this.entry;
    this.entryToDisplay = { field_type, field_name };
    let recordToDisplay = this.record;

    if (this.entry.field_type === 'reference') {
      recordToDisplay = this.record[this.entry.reference_to];
      this.entryToDisplay.field_type = reference_field_type;
      this.entryToDisplay.field_name = reference_field_name;
    }
    this.data = recordToDisplay[this.entryToDisplay.field_name];
  }
}
